import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const hi: Translations = {
  common: {
    appName: appName,
    loading: 'लोड हो रहा है...',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    back: 'वापस',
    search: 'खोजें',
    noResults: 'कोई परिणाम नहीं मिला',
    error: 'एक त्रुटि हुई',
    success: 'सफलता',
  },
  header: {
    searchPlaceholder: 'कोसर, हॉटगर्ल, आओ दाई, मॉडल खोजें...',
    searchPlaceholderMobile: 'खोजें...',
    home: 'होम',
    hotgirl: 'हॉटगर्ल',
    coser: 'कोसर',
    model: 'मॉडल',
    upload: 'अपलोड',
    notifications: 'सूचनाएं',
    login: 'लॉग इन',
    register: 'साइन अप',
  },
  footer: {
    tagline: `कोसर, हॉटगर्ल और मॉडल फ़ोटो साझा करने का सबसे अच्छा प्लेटफ़ॉर्म ${appName}।`,
    copyright: `© {year} ${appName}. सर्वाधिकार सुरक्षित।`,
    sections: {
      explore: 'एक्सप्लोर',
      account: 'अकाउंट',
      support: 'सहायता',
    },
    links: {
      home: 'होम',
      hotgirl: 'हॉटगर्ल',
      coser: 'कोसर',
      model: 'मॉडल',
      aoDai: 'आओ दाई',
      login: 'लॉग इन',
      register: 'साइन अप',
      upload: 'फ़ोटो अपलोड करें',
      dashboard: 'डैशबोर्ड',
      terms: 'सेवा की शर्तें',
      privacy: 'गोपनीयता नीति',
      report: 'उल्लंघन की रिपोर्ट करें',
      contact: 'संपर्क करें',
    },
  },
  collections: {
    title: 'संग्रह',
    createAlbum: 'एल्बम बनाएं',
    saved: 'सहेजे गए',
    noSaved: 'अभी तक कोई फ़ोटो सहेजी नहीं',
    noSavedHint: 'अभी फ़ोटो एक्सप्लोर करें →',
    removedSave: 'सहेजा हटाया गया',
    createModalTitle: 'नया एल्बम बनाएं',
    albumNamePlaceholder: 'एल्बम का नाम...',
    cancel: 'रद्द करें',
    create: 'बनाएं',
    albumCreated: 'एल्बम बनाया गया',
  },
  home: {
    title: 'खोजें',
    titleHighlight: 'सुंदरता',
    titleSuffix: 'जीवन की',
    subtitle: 'हर दिन अपडेट होती हजारों कोसर, हॉटगर्ल और मॉडल फ़ोटो',
    sortNewest: 'नवीनतम',
    sortTrending: 'ट्रेंडिंग',
    sortPopular: 'लोकप्रिय',
    allCategories: 'सभी',
    noMorePosts: 'आपने सभी फ़ोटो देख लीं',
  },
  auth: {
    login: {
      title: 'जारी रखने के लिए लॉग इन करें',
      continueWithGoogle: 'Google से जारी रखें',
      orLoginWithEmail: 'या ईमेल से लॉग इन करें',
      email: 'ईमेल',
      password: 'पासवर्ड',
      forgotPassword: 'पासवर्ड भूल गए?',
      submitButton: 'लॉग इन',
      loading: 'लॉग इन हो रहा है...',
      noAccount: 'अकाउंट नहीं है?',
      registerLink: 'अभी साइन अप करें',
      errorCredentials: 'गलत ईमेल या पासवर्ड',
      successLogin: 'सफलतापूर्वक लॉग इन हुए!',
    },
    register: {
      title: 'मुफ़्त अकाउंट बनाएं',
      displayName: 'प्रदर्शन नाम',
      displayNamePlaceholder: 'राहुल शर्मा',
      email: 'ईमेल',
      password: 'पासवर्ड',
      passwordPlaceholder: 'कम से कम 8 अक्षर',
      confirmPassword: 'पासवर्ड की पुष्टि करें',
      submitButton: 'साइन अप',
      loading: 'अकाउंट बन रहा है...',
      hasAccount: 'पहले से अकाउंट है?',
      loginLink: 'लॉग इन करें',
      errorPasswordMismatch: 'पासवर्ड मेल नहीं खाते',
      errorPasswordLength: 'पासवर्ड कम से कम 8 अक्षर का होना चाहिए',
      errorGeneric: 'रजिस्ट्रेशन विफल',
      successRegister: 'अकाउंट सफलतापूर्वक बनाया गया!',
      emailTaken: 'यह ईमेल पहले से उपयोग में है',
      serverError: 'सर्वर त्रुटि, बाद में पुनः प्रयास करें',
    },
    forgotPassword: {
      title: 'पासवर्ड भूल गए',
      subtitle: 'अपनी ईमेल दर्ज करें और हम रीसेट लिंक भेजेंगे',
      email: 'ईमेल',
      submitButton: 'रीसेट लिंक भेजें',
      backToLogin: 'लॉग इन पर वापस जाएं',
      sending: 'भेजा जा रहा है...',
      emailSent: 'ईमेल भेजी गई!',
      checkEmail: '{email} के इनबॉक्स में पासवर्ड रीसेट लिंक जांचें।',
      instructions: 'अपनी ईमेल दर्ज करें और हम पासवर्ड रीसेट करने का लिंक भेजेंगे।',
    },
  },
  userMenu: {
    dashboard: 'डैशबोर्ड',
    collections: 'संग्रह',
    settings: 'सेटिंग्स',
    logout: 'साइन आउट',
  },
  settings: {
    title: 'अकाउंट सेटिंग्स',
    profile: {
      nav: 'प्रोफ़ाइल',
      title: 'प्रोफ़ाइल जानकारी',
      displayName: 'प्रदर्शन नाम',
      username: 'उपयोगकर्ता नाम',
      website: 'वेबसाइट',
      bio: 'बायो',
      bioPlaceholder: 'अपना परिचय दें...',
      changeAvatar: 'अवतार बदलें',
      avatarHint: 'JPG, PNG, WebP अधिकतम 5MB',
      saveButton: 'बदलाव सहेजें',
      saving: 'सहेजा जा रहा है...',
      savedSuccess: 'बदलाव सहेजे गए',
    },
    password: {
      nav: 'पासवर्ड',
      title: 'पासवर्ड बदलें',
      fields: {
        currentPassword: 'वर्तमान पासवर्ड',
        newPassword: 'नया पासवर्ड',
        confirm: 'नए पासवर्ड की पुष्टि करें',
      },
      errors: {
        confirm: 'नए पासवर्ड मेल नहीं खाते',
        minLength: 'पासवर्ड कम से कम 8 अक्षर का होना चाहिए',
      },
      success: 'पासवर्ड सफलतापूर्वक बदला गया!',
      saving: 'सहेजा जा रहा है...',
      submit: 'पासवर्ड बदलें',
    },
    notifications: {
      nav: 'सूचनाएं',
      title: 'सूचना सेटिंग्स',
      options: {
        likes: 'जब कोई आपकी फ़ोटो लाइक करे',
        comments: 'जब कोई टिप्पणी करे',
        replies: 'जब कोई आपकी टिप्पणी का जवाब दे',
        follows: 'जब कोई आपको फ़ॉलो करे',
        approved: 'जब पोस्ट स्वीकृत हो',
        email_digest: 'साप्ताहिक ईमेल सारांश',
        marketing: 'प्रचार और इवेंट सूचनाएं',
      },
      saveSuccess: 'सूचना सेटिंग्स सहेजी गईं',
      saving: 'सहेजा जा रहा है...',
      saveButton: 'सेटिंग्स सहेजें',
    },
    security: {
      nav: 'सुरक्षा',
      twoFactorAuth: 'दो-कारक प्रमाणीकरण (2FA)',
      twoFactorAuthHint: 'ऐप से वेरिफिकेशन कोड से सुरक्षा बढ़ाएं',
      comingSoon: 'जल्द आ रहा है',
      activeSessions: 'सक्रिय सत्र',
      currentBrowser: 'वर्तमान ब्राउज़र',
      lastLogin: 'अंतिम लॉग इन',
      active: 'सक्रिय',
      dangerZone: 'खतरनाक क्षेत्र',
      deleteAccountHint: 'अकाउंट हटाने से आपका सारा डेटा स्थायी रूप से हट जाएगा।',
      deleteAccount: 'अकाउंट हटाएं',
    },
  },
  post: {
    likes: '{count} लाइक',
    views: '{count} व्यूज़',
    shares: '{count} शेयर',
    comments: '{count} टिप्पणियां',
    save: 'सहेजें',
    saved: 'सहेजा गया',
    share: 'शेयर करें',
    linkCopied: 'लिंक कॉपी हुआ!',
    follow: 'फ़ॉलो करें',
    following: 'फ़ॉलो कर रहे हैं',
    relatedPosts: 'संबंधित पोस्ट',
    commentPlaceholder: 'टिप्पणी लिखें...',
    commentLoginPlaceholder: 'टिप्पणी करने के लिए लॉग इन करें...',
    commentSubmit: 'पोस्ट करें',
    commentSubmitting: 'पोस्ट हो रही है...',
    noComments: 'अभी तक कोई टिप्पणी नहीं। पहले बनें!',
    savedToCollection: 'संग्रह में सहेजा गया',
    removedFromCollection: 'संग्रह से हटाया गया',
    description: 'विवरण',
    profileView: 'प्रोफ़ाइल देखें',
  },
  notifications: {
    title: 'सूचनाएं',
    empty: 'कोई सूचना नहीं',
    markAllRead: 'सभी पढ़ा हुआ चिह्नित करें',
    types: {
      like_post: 'ने आपकी फ़ोटो लाइक की',
      comment: 'ने आपकी फ़ोटो पर टिप्पणी की',
      reply: 'ने आपकी टिप्पणी का जवाब दिया',
      follow: 'ने आपको फ़ॉलो किया',
      approve: 'आपकी पोस्ट स्वीकृत हुई',
      reject: 'आपकी पोस्ट अस्वीकृत हुई',
      system: 'सिस्टम सूचना',
    },
  },
  search: {
    title: 'खोज परिणाम',
    result: 'परिणाम',
    tryOtherKeywords: 'अन्य कीवर्ड आज़माएं...',
    noResults: 'कोई परिणाम नहीं मिला',
    placeholder: 'खोजें...',
    thisHashtag: 'इस हैशटैग वाली फ़ोटो',
  },
  upload: {
    title: 'फ़ोटो अपलोड करें',
    dragDrop: 'खींचें और छोड़ें या चुनने के लिए क्लिक करें',
    supportedFormats: 'JPG, PNG, WebP, GIF समर्थित',
    submit: 'प्रकाशित करें',
    submitting: 'प्रकाशित हो रहा है...',
    titleField: 'शीर्षक',
    titlePlaceholder: 'आकर्षक शीर्षक दर्ज करें...',
    descriptionField: 'विवरण',
    descriptionPlaceholder: 'फ़ोटो सेट का विस्तृत विवरण...',
    hashtagsField: 'हैशटैग',
    statusField: 'स्थिति',
    statusPublic: 'सार्वजनिक',
    statusPrivate: 'निजी',
    statusDraft: 'ड्राफ्ट',
    error: 'अपलोड में त्रुटि',
    errorSelect: 'कम से कम 1 फ़ोटो चुनें',
    errorTitle: 'शीर्षक दर्ज करें',
    photos: 'फ़ोटो',
    uploading: 'अपलोड हो रहा है...',
  },
  notFound: {
    title: 'पेज नहीं मिला',
    subtitle: 'जिस पेज को आप ढूंढ रहे हैं वह मौजूद नहीं है।',
    backHome: 'होम पर वापस जाएं',
  },
  liked: {
    title: 'पसंद की गई पोस्ट',
    empty: 'आपने अभी तक कोई पोस्ट लाइक नहीं की।',
  },
  user: {
    unknown: 'अज्ञात',
  },
  globalError: {
    title: 'एक त्रुटि हुई',
    subtitle: 'असुविधा के लिए क्षमा करें। कृपया पुनः प्रयास करें।',
    retry: 'पुनः प्रयास करें',
  },
  username: {
    posts: 'पोस्ट',
    likes: 'लाइक',
    followers: 'फ़ॉलोअर',
    following: 'फ़ॉलोइंग',
    editProfile: 'प्रोफ़ाइल संपादित करें',
    message: 'संदेश',
    noPosts: 'अभी तक कोई पोस्ट नहीं।',
    bio: 'फ़ोटो देखें ',
    notFound: 'उपयोगकर्ता नहीं मिला',
  },
  topic: {
    notFound: 'विषय नहीं मिला',
    viewTitle: 'विषय देखें ',
  },
  dashboard: {
    title: 'डैशबोर्ड',
    welcome: 'नमस्ते',
    stats: {
      posts: 'पोस्ट',
      views: 'व्यूज़',
      likes: 'लाइक',
      comments: 'टिप्पणियां',
    },
  },
  adsblock: {
    title: 'आप AdBlock उपयोग कर रहे हैं',
    description: 'उच्च-गुणवत्ता वाली छवियां देखने और वेबसाइट को मुफ़्त रखने में मदद करने के लिए AdBlock अक्षम करें।',
    action: 'मैंने अक्षम कर दिया — पुनः लोड करें',
    cancel: 'छोड़ें',
  },
  pwa: {
    title: ` ${appName} को बेहतर अनुभव के लिए स्थापित करें!`,
    iosSubtitle: 'Share दबाएं → होम स्क्रीन पर जोड़ें',
    androidSubtitle: 'जैसे ही नए फोटो सेट जारी होते हैं, सूचित किया जाए',
    installButton: 'स्थापित करें',
    disclaimer: 'त्वरित स्थापना, कोई ऐप स्टोर आवश्यक नहीं।',
  },
  autotrans: {
    title: 'स्वचालित रूप से अनुवादित',
    translated: 'अनुवाद',
    origin: 'मूल सामग्री',
  },
  subscription: {
    title: 'सूचनाओं के लिए सदस्यता लें',
    description: 'जैसे ही नए फोटो सेट जारी होते हैं, सूचित किया जाए',
    subscribeButton: 'सदस्यता लें',
    unsubscribeButton: 'सदस्यता समाप्त करें',
    subscribed: 'आप सूचनाओं के लिए सदस्यता ले चुके हैं।',
    unsubscribed: 'आपने सूचनाओं के लिए सदस्यता समाप्त कर दी है।',
    error: 'आपकी सदस्यता को अपडेट करते समय एक त्रुटि हुई। कृपया पुनः प्रयास करें।',
    success_tit: '🎉 सूचनाएं सक्षम की गईं!',
    denied_tit: 'सूचनाएं अस्वीकृत',
    error_tit: 'एक त्रुटि हुई',
    success_des: 'आपको नए सामग्री उपलब्ध होने पर सूचनाएं प्राप्त होंगी।',
    denied_des: 'आप इन्हें अपने ब्राउज़र सेटिंग्स में फिर से सक्रिय कर सकते हैं।',
    error_des: 'कृपया बाद में पुनः प्रयास करें।',
    skip: 'छोड़ें',
    processing: 'प्रसंस्करण...',
    noti: 'सूचनाएं सक्षम करें',
    rule: 'केवल नए सामग्री के लिए सूचनाएं दिखाएं।',
    notify_title: `सूचनाएं - ${appName}`,
    notify_body: "नई गैलरी जारी की गई है। अभी इसे देखें!",
  },
  contact: {
    title: 'संपर्क करें',
    subtitle: 'हम आपसे सुनने के लिए उत्सुक हैं! कृपया नीचे दिए गए फॉर्म को भरें और हम जल्द से जल्द आपसे संपर्क करेंगे।',
    name: 'नाम',
    email: 'ईमेल',
    subject: 'विषय',
    message: 'संदेश',
    submitButton: 'संदेश भेजें',
    sending: 'भेजा जा रहा है...',
    successTitle: 'संदेश भेजा गया!',
    successMessage: 'हमसे संपर्क करने के लिए धन्यवाद। हम जल्द ही आपसे संपर्क करेंगे।',
    errorTitle: 'एक त्रुटि हुई',
    errorMessage: 'आपके संदेश को भेजने में एक त्रुटि हुई। कृपया बाद में पुनः प्रयास करें।',
    res_time_title: 'प्रतिक्रिया समय',
    res_time: 'हम आमतौर पर 1-3 कार्य दिवसों के भीतर प्रतिक्रिया देते हैं।',
    report_content: 'सामग्री की रिपोर्ट करें',
    report_content_hint: 'एक पोस्ट या उपयोगकर्ता की रिपोर्ट करने के लिए, सामग्री पर सीधे रिपोर्ट बटन का उपयोग करें या ऊपर &ldquo;सामग्री की रिपोर्ट करें&rdquo; का चयन करें।',
    value_default: 'एक विषय चुनें',
    value_general: 'सामान्य पूछताछ',
    value_report: 'सामग्री की रिपोर्ट करें',
    value_account: 'खाता समस्या',
    value_business: 'व्यापार / साझेदारी',
    value_feedback: 'प्रतिक्रिया और सुझाव',
    value_other: 'अन्य'
  },
  language: {
    label: 'भाषा',
    en: 'English',
    vi: 'Tiếng Việt',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    fr: 'Français',
    es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
} as const;

export default hi;